import { createAction, props } from '@ngrx/store';

import { ErrorStore, StridesStoreItem } from '@sleipai/sleip-models';

export const loadAnalysisStridesByIdAndPublicKey = createAction(
  '[AnalysistridesStrore] Load Shared AnalysisStrides',
  props<{
    publicRecordingId: string;
    publicKey: string;
    version: string;
    recordingId?: string;
  }>()
);

export const loadAnalysisStridesSuccess = createAction(
  '[AnalysistridesStrore] Load AnalysisStrides Success',
  props<{ data: StridesStoreItem }>()
);

export const loadAnalysisStridesFailure = createAction(
  '[AnalysistridesStrore] Load AnalysisStrides Failure',
  props<{ error: ErrorStore | string | null | any }>()
);

export const loadAnalysisStridesById = createAction(
  '[AnalysistridesStrore] Load AnalysisStrides',
  props<{ recordingId: string; isFlexion: boolean }>()
);
